import { PropertyGroup } from "../property-group";
import { levelProperty } from "./level-property";
import { crystalLevelProperty } from "./crystal-level-property";
import {characterBoardProperty} from './character-board-property'
import { ldBoardProperty } from "./ld-board-property";
import { forceEnhancementProperty } from "./force-enhancement-property";
import { frBoardProperty } from "./fr-board-property";

export const levelsGroup = new PropertyGroup("Levels", [levelProperty, crystalLevelProperty, characterBoardProperty, ldBoardProperty, forceEnhancementProperty, frBoardProperty])
